import { render, staticRenderFns } from "./MedSurveyPages.vue?vue&type=template&id=06a46976&scoped=true&"
import script from "./MedSurveyPages.vue?vue&type=script&lang=js&"
export * from "./MedSurveyPages.vue?vue&type=script&lang=js&"
import style0 from "./MedSurveyPages.vue?vue&type=style&index=0&id=06a46976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a46976",
  null
  
)

export default component.exports